import { render, staticRenderFns } from "./TalksSchedules.vue?vue&type=template&id=947a1daa&"
import script from "./TalksSchedules.vue?vue&type=script&lang=js&"
export * from "./TalksSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports